// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1337) return "static/chunks/1337-51ab61d289531104.js";
	if (chunkId === 4755) return "static/chunks/4755-5deea841976a7f05.js";
	if (chunkId === 5590) return "static/chunks/5590-d2e52b2203448841.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2336":"127e2158fe162489","2536":"74079d7c3e77c778","3340":"d08871638ac51bd1","3833":"04faf3755af85cd5","3924":"f2b0ae743da92abb","5841":"995d75f4d3f7f597","5857":"23f733ac084ab47e","6539":"992a5eae175858e7","7400":"b38d3d7c1d26959d","7965":"a3c62f5f7d497f82","8407":"7f011379c1b893dc","9354":"027d5bac74e6d5c0"}[chunkId] + ".js";
};